import { MatDialog } from '@angular/material';
import { ConfirmDialogComponent } from './confirm-dialog.component';
import * as i0 from "@angular/core";
import * as i1 from "@angular/material/dialog";
var ConfirmDialogService = /** @class */ (function () {
    function ConfirmDialogService(matDialog) {
        this.matDialog = matDialog;
    }
    ConfirmDialogService.prototype.open = function (data) {
        return this.matDialog.open(ConfirmDialogComponent, {
            autoFocus: false,
            data: data
        }).afterClosed()
            .toPromise();
    };
    ConfirmDialogService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ConfirmDialogService_Factory() { return new ConfirmDialogService(i0.ɵɵinject(i1.MatDialog)); }, token: ConfirmDialogService, providedIn: "root" });
    return ConfirmDialogService;
}());
export { ConfirmDialogService };
